import React from 'react';
import { Helmet } from 'react-helmet-async';
import { LegalEntityDetails } from '../components/common/LegalEntityDetails';
import { registrationIdentifiers } from '../lib/jsonLd';

export function CookiesPolicyPage() {
  const webSiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Fundacja Znajdki',
    url: 'https://znajdki.pl',
    publisher: {
      '@type': 'Organization',
      name: 'Fundacja Znajdki',
      legalName: 'Fundacja „Znajdki"',
      taxID: '1132860384',
      vatID: 'PL1132860384',
      identifier: registrationIdentifiers
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <Helmet>
        <title>Polityka cookies | Fundacja "Znajdki"</title>
        <meta name="description" content="Polityka plików cookies Fundacji Znajdki. Informacje o rodzajach, celu stosowania oraz sposobach zarządzania plikami cookies." />
        <meta property="og:title" content="Polityka cookies | Fundacja Znajdki" />
        <meta property="og:description" content="Informacje o plikach cookies stosowanych w serwisie Fundacji Znajdki." />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(webSiteJsonLd)}</script>
      </Helmet>

      <header className="mb-10">
        <h1 className="heading-1">Polityka cookies</h1>
        <p className="body-medium mt-4 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          Obowiązuje od: 08.09.2025
        </p>
      </header>

      <section className="space-y-8 text-accessible-gray-700 dark:text-accessible-gray-200 high-contrast:text-white">
        <LegalEntityDetails title="Administrator serwisu — dane rejestrowe" />

        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h2 className="heading-4 mb-3">Czym są pliki cookies?</h2>
          <p>Cookies to niewielkie pliki tekstowe zapisywane na urządzeniu Użytkownika podczas korzystania z Serwisu. Ułatwiają korzystanie ze strony i pozwalają na zapamiętywanie preferencji.</p>
        </div>

        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h2 className="heading-4 mb-3">Jakie pliki cookies stosujemy?</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Niezbędne – wymagane do prawidłowego działania Serwisu.</li>
            <li>Funkcjonalne – zapamiętujące ustawienia Użytkownika (np. dostępność, motyw).</li>
            <li>Analityczne – pomagające zrozumieć sposób korzystania z Serwisu (zbierane w formie zanonimizowanej).</li>
          </ul>
        </div>

        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h2 className="heading-4 mb-3">W jakich celach używamy cookies?</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Zapewnienie bezpieczeństwa i niezawodności działania Serwisu.</li>
            <li>Dostosowanie treści i funkcjonalności do preferencji Użytkownika.</li>
            <li>Pomiar ruchu i udoskonalanie dostępności serwisu.</li>
          </ul>
        </div>

        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h2 className="heading-4 mb-3">Zarządzanie plikami cookies</h2>
          <p>Użytkownik może w każdej chwili zmienić ustawienia cookies w swojej przeglądarce lub usunąć zapisane pliki. Ograniczenie stosowania cookies może wpłynąć na niektóre funkcje Serwisu.</p>
        </div>

        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h2 className="heading-4 mb-3">Więcej informacji</h2>
          <p>Szczegółowe informacje o przetwarzaniu danych znajdują się w <a className="underline" href="/polityka-prywatnosci">Polityce prywatności</a>.</p>
        </div>
      </section>
    </div>
  );
}


